import { STATUS_TYPE } from '../../../enum';
// import { Country } from '../../country/api/interface';
// import { Region } from '../../region/api/interface';

export interface Attachments {
    documentType: string;
    fileName: string;
    fileType: string;
    id: string;
    key: string;
}
export interface CreateUsers {
    // firstName: string;
    // lastName: string;
    name: string;
    mobileNumber: string;
    email: string;
    password: string;
    countryCallingCode: string;
    language: string;
    userRole: string;
    // language: string,
    // countryId: string,
    // regionId: string,
}

export interface UpdateUserProfile {
    id: string;
    name: string;
    language: string;
    description?: string | null;
    attachmentId?: string | null;
}

export interface UpdateUserPassword {
    id: string;
    oldPassword: string;
    newPassword: string;

}

export interface GetUsers {
    organizationId: string;
    limit: number;
    skip: number;
}

export interface FindUsers {
    id: string;
    organizationId: string;
}

export interface FindUserList {
    isUser?: boolean;
    search?: string;
    userRole?: string;
    isApproved?: boolean;
    limit?: number;
    skip?: number;
    excludeInactive?: boolean;
}

export interface RemoveUsers {
    id: string;
    organizationId: string;
}
export interface Users {
    id: string;
    // firstName: string;
    // lastName: string;
    name: string;
    mobileNumber: string;
    email: string;
    password: string;
    // balance: string;
    // countryCode: string;
    countryCallingCode: string;
    language: string;
    isApproved: boolean;
    attachments: Attachments[];
    rejectionReason: string;
    // countryId: string;
    // country: Country
    // regionId: string;
    // region: Region;
    freeAds: string;
    maxAds: string;
    activeState: boolean;
    userRole: string;
    createdAt: string;
    updatedAt: string;
    isSuspendedDueToLicenseExpiration?: boolean;
}

export interface InitialState {
    data: Users[];
    skip: number;
    limit: number;
    totalRecords: number;
    currentPage: number;
    status: STATUS_TYPE;
    isError: boolean;
    isLoading: boolean;
    isSuccess: boolean;
    errorMessage: string;
}

export const initialState: InitialState = {
    data: [],
    skip: 0,
    limit: 25,
    totalRecords: 0,
    currentPage: 0,
    status: 'idle',
    isError: false,
    isLoading: false,
    isSuccess: false,
    errorMessage: '',
};
